module.exports = __webpack_public_path__ + "static/media/multi.f5c45a4b.svg";